var render = function render(){var _vm=this,_c=_vm._self._c;return _c('geko-base-crud',{attrs:{"config":_vm.config},on:{"create-success":_vm.onCreateSuccess},scopedSlots:_vm._u([{key:"list-indicator",fn:function({ item }){return [_c('div',{staticClass:"indicator-wrapper pt-1"},[_c('div',{staticClass:"indicator",class:{
        info: item.job_status == 'Training',
        success: item.job_status == 'Active',
      }})])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }